module.exports = __webpack_public_path__ + "img/svg/background-stars-filled.e114b2d55b2e639c2265653d2d4d632e.svg";